// React:
import React, { useEffect, useState } from "react";
// Redux Toolkit Hooks:
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
// Redux Toolkit Actions & State:
import { directory } from "../home/directory/directorySlice";
import { directoryItems } from "../home/directory/directory-items/directoryItemsSlice";
// MUI Components:
import { Grid, Box, Typography, useTheme, SvgIcon } from "@mui/material";
// Components:
import ShareManagementTable from "./share-management-table/ShareManagementTable";
// MUI Styles:
import { makeStyles } from "@mui/styles";
// Icones:
import { ReactComponent as FolderHomeIcon } from "../../../assets/icons/folder-home-icon.svg";
import { eraseCookie } from "../../../configs/cookie-helper/cookieHelper";
import {
  authentication,
  logoutAction,
} from "../../authentication/authenticationSlice";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  pathBox: {
    "&::-webkit-scrollbar": {
      borderRadius: "10px",
      height: "7px",
      width: "7px",
    },
    "&::-webkit-scrollbar-track": {
      borderRadius: "10px",
      backdropFilter: "blur(4px)",
      backgroundColor: "rgba(28, 33, 45, 0.4)",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      backgroundColor: theme.palette.secondary.main,
    },
  },
}));

const ShareManagement = () => {
  const classes = useStyles();
  const theme = useTheme();

  const {
    directoryData: { path, actionStatus, alert },
  } = useAppSelector(directory);
  const { itemInfo } = useAppSelector(directoryItems);

  const dispatch = useAppDispatch();

  const [authStatus, setAuthStatus] = useState({ message: "", loading: false });

  const navigate = useNavigate();

  const { token } = useAppSelector(authentication);

  useEffect(() => {
    if (actionStatus === "loading") {
      setAuthStatus({ message: alert.message, loading: true });
    }

    if (!!token && actionStatus === "success") {
      setAuthStatus({ message: alert.message, loading: false });
    }

    if (actionStatus === "rejected") {
      setAuthStatus({ message: alert.message, loading: false });
    }
  }, [token, actionStatus, alert.message]);

  useEffect(() => {
    if (authStatus.message === "login_again") {
      eraseCookie("token");
      eraseCookie("username");
      eraseCookie("rule");
      navigate("/login");
      dispatch(logoutAction());
    }
  }, [authStatus, navigate, dispatch]);

  return (
    <>
      <Grid item xs={12}>
        <Typography
          sx={{
            fontSize: "24px",
            color: (theme) => theme.palette.text.secondary,
            mb: "8px",
            [theme.breakpoints.down("md")]: {
              fontSize: "20px",
              mb: "6px",
            },
          }}
        >
          Share management
        </Typography>

        <Box
          sx={{
            width: "100%",
            height: "fit-content",
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            mb: "8px",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "flex-start" }}>
            <SvgIcon
              component={FolderHomeIcon}
              inheritViewBox
              sx={{
                width: "auto",
                height: "24px",
                color: theme.palette.secondary.light,
                [theme.breakpoints.down("md")]: {
                  height: "20px",
                },
              }}
            />
            <Typography
              sx={{
                lineHeight: "revert",
                fontSize: "18px",
                color: (theme) => theme.palette.text.secondary,
                mx: "8px",
                [theme.breakpoints.down("md")]: {
                  fontSize: "16px",
                },
              }}
            >
              /
            </Typography>
          </Box>

          <Box
            sx={{ overflowX: "auto", display: "flex", alignItems: "center" }}
            className={classes.pathBox}
          >
            {path !== "" &&
              path.split("/").map((item, index) => (
                <Box
                  sx={{ display: "flex", alignItems: "flex-start" }}
                  key={index}
                >
                  <Typography
                    sx={{
                      lineHeight: "revert",
                      fontSize: "18px",
                      color: theme.palette.text.secondary,
                      [theme.breakpoints.down("md")]: {
                        fontSize: "16px",
                      },
                    }}
                  >
                    {item}
                  </Typography>

                  <Typography
                    sx={{
                      lineHeight: "revert",
                      fontSize: "18px",
                      color: theme.palette.text.secondary,
                      mx: "8px",
                      [theme.breakpoints.down("md")]: {
                        fontSize: "16px",
                      },
                    }}
                  >
                    /
                  </Typography>
                </Box>
              ))}
            <Typography
              sx={{
                lineHeight: "revert",
                fontSize: "18px",
                color: theme.palette.text.secondary,
                [theme.breakpoints.down("md")]: {
                  fontSize: "16px",
                },
              }}
            >
              {itemInfo.name}
            </Typography>
          </Box>
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{
          height: "calc(100% - 79px)",
          [theme.breakpoints.down("md")]: {
            height: "calc(100% - 68px)",
          },
        }}
      >
        <ShareManagementTable />
      </Grid>
    </>
  );
};

export default ShareManagement;
